import { jsx as _jsx } from "react/jsx-runtime";
import TypographyMUI from "@mui/material/Typography";
export const Typography = (props) => {
    return (_jsx(TypographyMUI, Object.assign({}, props, { variantMapping: { subtitle1: "div", subtitle2: "div" } })));
};
export default Typography;
